export const AddModificationButtonText = "Add modification";
export const AddSpecialModificationButtonText = "Add Special Modification";
export const AddModificationHeader = "Modifications";
export const AddSpecialModificationHeader = "Special Modifications";
export const AddModificationPlaceholder = "Select Modification Type";
export const AddModificationRemoveText = "Remove";
export const AddModificationIncrementError = "Please make a selection";
export const AddModificationQuickAddText = "Press Shift + Tab to add another modification";
export const SpecialModsText = "Special Modifications";
export const SelectModTypeText = "Select Modification Type";
export const ModDescriptionText = "Modification Description";
export const UpchargeText = "Upcharge";
export const CQModificationsHeaderText = "CQ Modifications";
export const CQCodeLabelText = "CQ Code";
export const CQCustomizationsHeaderText = "CUSTOMIZATIONS";
